import { AnalyticsEventTopic, MORE_RESOURCES_EVENT_CONTEXT } from '../analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

interface MarketingAnalyticsResourceViewEvent extends MarketingAnalyticsEvent {
    media_type: string;
}

export class MarketingAnalyticsResourceViewType extends MarketingAnalyticsEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.context === MORE_RESOURCES_EVENT_CONTEXT;
    }

    getBody(event: any): MarketingAnalyticsResourceViewEvent {
        const baseEvent = this.baseEvent(event);
        return {
            ...baseEvent,
            media_type: this.mapMediaType(event.customTitle),
        };
    }

    mapMediaType(type: string): string {
        const mediaTypeMap = {
            'data sheet': 'Datasheet',
            'customization guide': 'Customization Guide',
            'case study': 'Case Study',
            webinar: 'Webinar',
            whitepaper: 'Whitepaper',
            'customer testimonial': 'Customer Testimonial',
        };
        // @ts-expect-error * Automated Type Error Fix
        return mediaTypeMap[type.toLocaleLowerCase()] || type;
    }
}
